import { Divider } from "@flat-ui";
import { Box } from "@mui-wrapper";
import { FormContainer } from "@components/forms/form-container";
import { InfoRow } from "@components/info-row";
import { ContentLayout } from "@pages/content-layout";
import { formatProjectArea } from "@utils/data-display";
import { useProjectCreationContext } from "@pages/create-project/project-creation-context";
import { getProjectManagerDisplay } from "@utils/project-utils";
import { StringHeader } from "@components/string-header";

interface Props {
  /** Function called when the user clicks on the "confirm" button */
  onConfirmCreation(): void;
}

export function ProjectSummaryPage({
  onConfirmCreation,
}: Props): React.JSX.Element {
  const projectCreationContext = useProjectCreationContext();

  const {
    subject,
    setShouldShowSummary,
    projectName,
    projectAddress,
    projectArea,
    projectAreaUnit,
    projectManager,
    isStandalone,
  } = projectCreationContext;

  return (
    <ContentLayout header={<StringHeader title="Project Summary" />}>
      <FormContainer
        sx={{
          width: "550px",
          ml: "110px",
          mt: "10px",
          "& .MuiFormControl-root": {
            mt: "20px",
          },
        }}
        cancelButtonText="Back"
        handleCancelClicked={() => setShouldShowSummary(false)}
        createButtonText="Confirm"
        handleCreateClicked={onConfirmCreation}
      >
        <p>Confirm the project details.</p>
        <Box sx={{ fontSize: "20px", mb: "20px" }}>Project Details</Box>

        <Box sx={{ pl: "10px" }}>
          <InfoRow
            labelTextAlign="left"
            label="Project Name"
            info={projectName}
          />

          <InfoRow
            labelTextAlign="left"
            label="Project Address"
            info={projectAddress}
          />

          <InfoRow
            labelTextAlign="left"
            label="Project Area"
            info={formatProjectArea({
              amount: projectArea ?? 0,
              unit: projectAreaUnit,
            })}
          />

          <InfoRow
            labelTextAlign="left"
            label="Standalone"
            info={isStandalone ? "Yes" : "No"}
          />

          <Divider sx={{ m: "20px 0px 10px 0px" }} />

          <Box sx={{ fontSize: "20px", mb: "20px" }}>Project Assignment</Box>
          <InfoRow
            labelTextAlign="left"
            label="Assigned workspace"
            info={subject.company.name}
          />
          <InfoRow
            labelTextAlign="left"
            label="Assigned group"
            info={subject.group.name}
          />

          <InfoRow
            labelTextAlign="left"
            label="Project Manager"
            info={getProjectManagerDisplay(
              subject.groupMembers,
              projectManager
            )}
          />
        </Box>
      </FormContainer>
    </ContentLayout>
  );
}
